import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { MobileCallBar } from './MobileCallBar';
import { ScrollManager } from './ScrollManager';
export function SiteLayout() {
  return <div className="min-h-screen w-full bg-white" data-id="element-418" data-mp="34u39h66i2yqm">
      <ScrollManager data-id="element-419" data-mp="39ur7ibt5cfuc" />
      <Header data-id="element-420" data-mp="39v908yglobxi" />
      <main data-id="element-421" data-mp="39vsjqjlwf8dn">
        <Outlet data-id="element-422" data-mp="39sejpi0pjb9d" />
      </main>
      <Footer data-id="element-423" data-mp="3dwcj7tty2o2y" />
      <MobileCallBar data-id="element-424" data-mp="3dwukx5zdlui9" />
    </div>;
}